import { IStorageData, IStorageProvider, IAceClientOptions } from './types';

export class Storage {
  static async isWritable(storage: IStorageProvider<IStorageData>): Promise<boolean> {
    const testStorageKey = 'ace-sdk-test';
    const testStorageValue = 'ace-sdk-test-value';

    try {
      await storage.setItem(testStorageKey, testStorageValue);
      await storage.removeItem(testStorageKey);

      return true;
    } catch (e) {
      return false;
    }
  }

  private storage: IStorageProvider<IStorageData>;
  private key: string;

  constructor({ storage, storageKey }: Pick<IAceClientOptions, 'storage' | 'storageKey'> = {}) {
    this.storage = storage || window.localStorage;
    this.key = storageKey || 'ace-sdk-tokens';
  }

  async read(key?: string): Promise<IStorageData> {
    return this.storage.getItem(key || this.key);
  }

  async write(data: string, key?: string): Promise<void> {
    if (!Storage.isWritable(this.storage)) {
      return Promise.reject('Storage is not writable');
    }

    if (data) {
      return this.storage.setItem(key || this.key, data);
    }
  }

  async clear(key?: string): Promise<void> {
    return this.storage.removeItem(key || this.key);
  }
}
